/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![VoiceLockIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABeUlEQVR4nN2Vvy8EQRTH90KCBtGI3h+gR7bQbHHvx0nGe1zkWo2oFRL/gh7/AAqh0rmLViJRqCQaCYXQi5PZ25M1t3vm7EXwkkn2zZv5fmbevJkNgr9gyLIBJPetpus9C1Qq1SlkuUaShhsjknlkbSLpCZCcIutbmZfnvMWjqDoKLJexCGvTjQPrpu2PomjINvtt+7zEjTEjwHreFncBwHqRjn1qGbt1xQeQ9MidmB6TK56z27SVkHX3q0k9Abpul/sA8BHHHweQNPLGAWu9MKAn+5UAY8wEsjwh6531w1pt2Pr2yegLAJJbjCRn1idamUnyf1MYUCZZBdLXWLCiUQwk2Yp9kr3CACB9TsS2k3SNAcmD7SuTLHQCupQcZgCQda29cvusAMtBZnnmWAlY932qyK4cWQ5bcXkBMNM+gCAMw0FgOc5NEehknHPSxw/xxaVZL3Hnua7npOg2fWu9V+4aUW0cWa46D1l2bLVkHuh3f5ngeYD/y94Bc1HdGD0jRXsAAAAASUVORK5CYII=)
 */
export const VoiceLockIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M16 4h.5v-.5a2.5 2.5 0 0 1 5 0V4h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Zm4-.5V4h-2v-.5a1 1 0 1 1 2 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M11 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1h-.06a1 1 0 0 1-.74-.32L5.92 17H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h2.92l4.28-4.68a1 1 0 0 1 .74-.32H11ZM20.5 12c-.28 0-.5.22-.52.5a7 7 0 0 1-5.13 6.25c-.48.13-.85.55-.85 1.05v.03c0 .6.52 1.06 1.1.92a9 9 0 0 0 6.89-8.25.48.48 0 0 0-.49-.5h-1ZM16.5 12c-.28 0-.5.23-.54.5a3 3 0 0 1-1.33 2.02c-.35.23-.63.6-.63 1.02v.14c0 .63.59 1.1 1.16.83a5 5 0 0 0 2.82-4.01c.02-.28-.2-.5-.48-.5h-1Z"
        className={colorClass}
      />
    </svg>
  );
};
